import { createContext } from "react"
import { SelectionManager } from "./ImagePicker/Stores/selection-manager"

export type SharedContextType = {
  dispose: () => void
  defer: (dispose: () => void) => void
  locale: any
  selection: SelectionManager
  completeOnSelect?: boolean
}

export class SharedContextData implements SharedContextType {
  private disposables: (() => void)[] = []
  locale: any
  selection: SelectionManager
  completeOnSelect: boolean | undefined

  constructor(e: { locale: any; selection: SelectionManager; completeOnSelect?: boolean }) {
    this.locale = e.locale
    this.selection = e.selection
    this.completeOnSelect = e.completeOnSelect
  }

  dispose() {
    this.disposables.forEach((dispose) => dispose())
    this.disposables.length = 0
  }

  defer(dispose: () => void) {
    this.disposables.push(dispose)
  }
}

export const SharedContext = createContext<SharedContextType>(null as any)
